import React from 'react';
import { Text, View } from 'react-native';
import { getMediumFont } from '../../../../utils/Utils';
//= ========================================================================

const SquareWithTextMessage = ({
  globJSON, simPlatform, text,
}) => {
  const { colors } = globJSON.configurations.theme;
  const myStyle = {
    container: {
      width: 152,
      height: 64,
      alignSelf: 'center',
      borderRadius: globJSON.configurations.theme.radius.elements_shape_square ? 3 : 15,
      backgroundColor: colors.primary_cta_color,
      justifyContent: 'center',
    },
    txtStyle: {
      width: 96,
      height: 26,
      fontFamily: `${getMediumFont(globJSON, simPlatform)}`,
      textAlign: 'center',
      alignSelf: 'center',
      fontSize: 10.4,
      color: colors.cta_font_color,
    },
  };
  return (
    <View style={myStyle.container}>
      <Text style={myStyle.txtStyle}>
        {text}
      </Text>
    </View>
  );
};
export default SquareWithTextMessage;
